export const EmptyOpenedTradeOption = {
  marketBuy: 0,
  marketSell: 0,
  limitBuy: 0,
  limitSell: 0,
  marketStep: 0,
  limitStep: 0,
  isEnabled: false,
  isFastEnable: false,
  isFastLimitEnable: false,
  isRecording: false,
}

export const emptyMarketPrecisionDepths = {
  firstEx: {
    symbolFullName: 'N/A',
    pricePrecision: 0,
    volumePrecision: 0,
    volume24: 0,
    change24: 'N/A',
    isActualMarket: true,
  },
  secondEx: {
    symbolFullName: 'N/A',
    pricePrecision: 0,
    volumePrecision: 0,
    volume24: 0,
    change24: 'N/A',
    isActualMarket: true,
  },
}

export const emptyActionsInfo = {
  totalProfit: 0,
  totalFee: 0,
  pureProfit: 0,
  posProfit: 0,
  negProfit: 0,
  fullVolume: 0,
  actions24count: 0,
  pagesCount: 0,
}

export const emptyWithdrawSymbols = {
  firstEx: {
    symbolNames: [],
    symbols: [],
  },
  secondEx: {
    symbolNames: [],
    symbols: [],
  },
}

export const emptyAllBalances = {
  balances: [],
  fiatTotal: 0,
  btcTotal: 0,
  pages: 0,
  generalTurnover24: 0,
  generalParts: { cex: 0, dex: 0 },
}

export const emptyWithdrawBalances = {
  firstBalance: 0,
  firstBalancePrecision: 0,
  secondBalance: 0,
  secondBalancePrecision: 0,
}

export const emptyPlaceOrderBalances = {
  firstBalance: 0,
  firstBalancePrecision: 0,
  secondBalance: 0,
  secondBalancePrecision: 0,
}
